import { isArray, isNumber, isString } from './type';
/** @internal */

var capitalizeWord = function capitalizeWord(value) {
  return "".concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
};
/** @public */


export var capitalize = function capitalize(value) {
  if (isArray(value) && value.every(function (item) {
    return isString(item);
  })) {
    return value.map(function (item) {
      return capitalizeWord(item);
    }).join(' ');
  }

  if (!isString(value)) return value;
  return value.split(' ').map(function (item) {
    return capitalizeWord(item);
  }).join(' ');
};
export var onlyNumbers = function onlyNumbers(value) {
  return isString(value) ? value.replace(/[^\d]/g, '') : value;
};
export var onlyNumbersWithPound = function onlyNumbersWithPound(value) {
  return isString(value) ? value.replace(/[^\d#]/g, '') : value;
};
export var truncateText = function truncateText(value, length) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$end = _ref.end,
      end = _ref$end === void 0 ? '...' : _ref$end;

  if (isString(value) && length && isNumber(length) && value.length > length) {
    return "".concat(value.slice(0, length)).concat(end);
  }

  return value;
};
export var filterByTerm = function filterByTerm(items, searchTerm, prop) {
  if (!isArray(items) || !isString(searchTerm) || prop && !isString(prop)) {
    return [];
  }

  return items.filter(function (item) {
    return prop ? item[prop].toLowerCase().includes(searchTerm.toLowerCase()) : item.toLowerCase().includes(searchTerm.toLowerCase());
  });
};